import { Storage } from '@lightningjs/sdk'

const LIMIT = 50
const KEY = 'flo-watch-history'

type ContinueWatchingItem = {
  nodeId: string | number
  progress: number
}

export const saveInWatchHistory = (vod: ContinueWatchingItem) => {
  if (!vod?.nodeId) return
  const existing = JSON.parse(Storage.get(KEY)) || []
  const filtered = existing.filter((item) => item.nodeId !== vod.nodeId)
  filtered.unshift(vod)
  const limited = filtered.slice(0, LIMIT)
  Storage.set(KEY, JSON.stringify(limited))
}

export const getWatchHistory = () => {
  return JSON.parse(Storage.get(KEY)) || []
}

export const getWatchHistoryItem = (id) => {
  const items = getWatchHistory() as ContinueWatchingItem[]
  return items.find((item) => item.nodeId === id)
}

export const deleteWatchHistory = () => {
  Storage.remove(KEY)
}

export const removeFromWatchHistory = (id) => {
  const items = getWatchHistory() as ContinueWatchingItem[]
  const newArray = items.filter((item) => item.nodeId !== id)
  Storage.set(KEY, JSON.stringify(newArray))
}
